(function () {
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var st = e.target.closest('[data-qty-step]');
    if (st) {
      var input = st.closest('.qty').querySelector('[data-qty]');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(st.dataset.qtyStep, 10));
      return;
    }
    var b = e.target.closest('[data-buy]');
    if (!b) return;
    var box = b.closest('[data-variant]');
    var q = box.querySelector('[data-qty]');
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    var code = box.dataset.code;
    var prepaid = b.dataset.buy === 'prepaid';
    b.disabled = true;
    fetch(root + 'cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(box.dataset.variant), quantity: qty }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        location.href = (prepaid && code)
          ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout')
          : root + 'checkout';
      })
      .catch(function () { b.disabled = false; location.href = root + 'cart'; });
  });

  $$('.th').forEach(function (t) {
    t.addEventListener('click', function () {
      var m = document.getElementById('main-img');
      if (m) { m.removeAttribute('srcset'); m.src = t.dataset.full || t.src; }
    });
  });

  var vids = $$('.cl video');
  if (vids.length) {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.controls = true; });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          if (x.isIntersecting) { var p = x.target.play(); if (p && p.catch) p.catch(function () {}); }
          else x.target.pause();
        });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { v.muted = true; io.observe(v); });
    }
  }

  $$('[data-ba]').forEach(function (b) {
    var d = b.querySelector('.hd');
    var p = 50;
    function set(v) {
      p = Math.min(100, Math.max(0, v));
      b.style.setProperty('--p', p + '%');
      d.setAttribute('aria-valuenow', Math.round(p));
    }
    function mv(e) {
      var r = b.getBoundingClientRect();
      set((e.clientX - r.left) / r.width * 100);
    }
    b.addEventListener('pointerdown', function (e) {
      b.setPointerCapture(e.pointerId);
      mv(e);
      b.onpointermove = mv;
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      b.addEventListener(t, function () { b.onpointermove = null; });
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') set(p - 5);
      if (e.key === 'ArrowRight') set(p + 5);
    });
    set(50);
  });
})();
